import React from "react";

const defaultRect = {
  width: 0,
  height: 0,
};

/**
 * Returns the value of getBoundingClientRect() for whichever element the ref is set on.
 *
 * e.g. Getting the width and height of a div
 * ```jsx
 * const [ref, boundingRect] = useBoundingClientRect()
 * const {width, height} = boundingRect;
 * return (<div ref={ref}>My div</div>)
 * ```
 */
export default function useBoundingClientRect() {
  const ref = React.useRef(null);
  const [boundingRect, setBoundingRect] = React.useState(defaultRect);

  React.useEffect(() => {
    // set state to ref bounding client rect (if it exists)
    function handleResize() {
      if (ref && ref.current && ref.current.getBoundingClientRect) {
        setBoundingRect(ref.current.getBoundingClientRect());
      }
    }
    // set initial value
    handleResize();
    // update on resize
    window.addEventListener("resize", handleResize);
    // cleanup
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [setBoundingRect]);

  return [ref, boundingRect];
}
